import React, { useRef, useEffect, useState } from "react";
import "./ForthSection.css";

const ForthSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (currentSection) observer.observe(currentSection);

    return () => {
      if (currentSection) observer.unobserve(currentSection);
    };
  }, []);

  return (
    <div
      className={`forth-section-container ${isVisible ? "visible" : ""}`}
      ref={sectionRef}
    >
      <div className="forth-box">
        {/* ✅ Top Icon */}
        <div className="forth-icon-wrapper">
          <img
            src="/assets/Admin.Enginnering.TAGS.png"
            alt="Helmet Icon"
            className="forth-icon-img"
          />
        </div>

        {/* ✅ Heading */}
        <h2>
          HEXAGON PPM SMART 3D /AVEVA EVERYTHING3D Admin. Draw and Supports
        </h2>

        {/* ✅ Content Section */}
        <div className="forth-list-section">
          <ul>
            <li>Creation and preparation of a project on DRAW</li>
            <li>Creation of template and backing sheet</li>
            <li>Creation of different library (Symbol, label, tag)</li>
            <li>Creation of representation rules and hatching rules</li>
            <li>Creation of visual layers, visual styles, and view section indicator</li>
            <li>Configure the System defaults</li>
            <li>Delivery of and installation support for upgrades</li>
            <li>
              Setup package – contains various labels, dimensions, graphic and
              other rules (view styles, filters) and an excel report template
            </li>
            <li>S3D drawing templates – Smart sketch border and layout file</li>
          </ul>
        </div>

        {/* ✅ Three Images with sharp edges + captions */}
        <div className="forth-bottom-images">
          <div className="forth-image-wrapper">
            <img
              src="/assets/forth-Section-image1.jpg"
              alt="Pipe Support Library"
              className="forth-bottom-img"
            />
            <p className="forth-caption">Pipe Support Library Preparation Work Process</p>
          </div>

          <div className="forth-image-wrapper">
            <img
              src="/assets/forth-Section-image2.png"
              alt="CAD Support Example"
              className="forth-bottom-img right"
            />
          </div>

          <div className="forth-image-wrapper">
            <img
              src="/assets/forth-Section-image3.png"
              alt="Engineering Setup"
              className="forth-bottom-img right"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForthSection;
